<template>
  <div class="premium">
    <router-view />
    <div class="fix-btn" @click="serachQuoteData">询价管理</div>
    <a-modal :width="1000" title="询价信息查询" @cancel="isSearchQuoteData = false" :visible="isSearchQuoteData" :footer="null">
        <a-form-model layout="inline" :model="quoteForm" :colon="false" :rules="quoteFormRule" ref="quoteForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
            <a-form-model-item label="询价单号" prop="appQuesNo">
                <a-input v-model="quoteForm.appQuesNo" allow-clear />
            </a-form-model-item>
            <a-form-model-item>
                <a-button type="primary" @click="serachQuoteSubmit">查询</a-button>
            </a-form-model-item>
        </a-form-model>
        <a-table :columns="column" :data-source="quoteData" size="small" :locale="{emptyText: '暂无数据'}" :pagination="false" class="quote-data-table">
            <div slot="operation" slot-scope="record">
                <a-button v-if="record.status === '-1'" type="link" class="mar-right10" @click="toEditData(record)" >
                    编辑
                </a-button>
            </div>
        </a-table>
    </a-modal>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {        
    const column = [
        { title: "询价编号", dataIndex: "id"},
        { title: "投保人", dataIndex: "contactsName"},
        { title: "状态", dataIndex: "status", customRender: (val) => {
            for (let i = 0; i < this.statusCode.length; i ++) {
                if (this.statusCode[i].code === val) {
                    return this.statusCode[i].name
                }
            }
            return val
        }},
        { title: "保费", dataIndex: "totalPremium"},
        { title: "创建日期", dataIndex: "createDate", customRender: (val) => {
            return moment(val).format('YYYY-MM-DD')
        }},
        { title: "最近更新日期", dataIndex: "updataDate", customRender: (val) => {
            return moment(val).format('YYYY-MM-DD')
        }},
        { title: "操作", key: "operation", align: "center", width: "80px", scopedSlots: { customRender: "operation" }}
    ]
    return {
      isSearchQuoteData: false,
      quoteForm: {
          appQuesNo: '',
      },
      column,
      form: {
        productCode: '',
        appQuesNo: '',
        webCustomerId: '',
      },
      quoteData: [],
      statusCode: [
          { code: '-1', name: '未提交' },
          { code: '-2', name: '审批中' },
          { code: '-3', name: '审批退回' },
          { code: '0', name: '待核保' },
          { code: '5', name: '核保中' },
          { code: '6', name: '核保通过' },
          { code: '7', name: '拒保' },
          { code: '11', name: '核保通过|缺失' }
      ],
      quoteFormRule: {
          appQuesNo: [
              { required: true, message: "请输入询价单号" }
          ]
      },
    }
  },
  mounted() {
    // 删除订单管理 保单管理按钮
    const right_nav = document.getElementsByClassName('right_nav')
    right_nav[0] && right_nav[0].remove()
    const { u, p, appQuesNo } = this.$route.query || {}
    this.form.productCode = p
    this.form.webCustomerId = u
    this.form.appQuesNo = appQuesNo;
  },
  methods: {
    // 点击询价管理按钮
    serachQuoteData() {
        this.isSearchQuoteData = true;
        this.quoteForm.appQuesNo = ''
        this.quoteData = []
    },
    // 询价管理查询
    serachQuoteSubmit() {
        this.$refs.quoteForm.validate(valid => {
            if (!valid){
                return false;
            }
            const data = {
                ...this.quoteForm,
                productCode: this.form.productCode
            }
            this.quoteData = []
            this.$api.queryMediLinkQuoAFP(data).then(res => {
                const data = res.data || {}
                if (data.returnCode == '00') {
                    const quoteData = data.content || {}
                    this.quoteData = [quoteData]
                } else {
                    this.$message.error(data.returnMsg || '出错了')
                }
            })
        })
    },
    // 编辑询价数据
    toEditData(record) {
        const { appQuesNo } = record
        if(!appQuesNo){return false;}
        this.isSearchQuoteData = false;

        if (appQuesNo === this.form.appQuesNo) { // 点击编辑的数据和当前查看的是一样的则初始化数据
            return true
        }
        this.$router.replace({
            name: this.form.productCode,
            query: {
                ...this.$route.query,
                appQuesNo
            }
        })
    },
  }

}
</script>

<style lang="scss" scoped>
.fix-btn{
    position: fixed;
    bottom: 50%;
    right: 0;
    color: #fff;
    padding: 12px 6px;
    -ms-writing-mode: tb-rl;
    writing-mode: vertical-rl;
    border: 1px solid rgb(254, 143, 45);
    border-right: none;
    background-color: rgb(254, 143, 45);
    margin: 15px 0;
    cursor: pointer;
}
.quote-data-table{
    margin-top: 20px;
}
.premium{
  padding-bottom: 30px;
}
</style>